"use strict";

var moment = require('moment-business-days');

var defaultDateFormat = 'ddd MMM DD YYYY';

function calculateShipDate(order) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var letterpressShipDate;
  var printingPlusShipDate;
  var printDateLetterpress;
  var printDate;
  var dateFormat = options.dateFormat || defaultDateFormat;
  var today = moment().startOf('day');
  var daysToPrintLetterpress = 10;

  if (order.printing_type.match(/RUSH/i)) {
    daysToPrintLetterpress = 4;
  }

  if (order.has_letterpress && order.is_international) {
    printDate = today.businessAdd(daysToPrintLetterpress + 1);
    printingPlusShipDate = printDate.format(dateFormat); // adding this here bc I think we need a letterpressShipDate internally

    printDateLetterpress = today.businessAdd(daysToPrintLetterpress);
    letterpressShipDate = printDateLetterpress.format(dateFormat);
  } else {
    if (order.has_letterpress) {
      printDateLetterpress = today.businessAdd(daysToPrintLetterpress);
      letterpressShipDate = printDateLetterpress.format(dateFormat);
    }

    var daysToPrint = 3;

    if (order.printing_type.match(/1 DAY/i)) {
      if (moment().hours() >= 15) {
        daysToPrint = 2;
      } else {
        daysToPrint = 1;
      }
    } else if (order.printing_type.match(/2 DAY|RUSH/i)) {
      daysToPrint = 2;
    }

    printDate = today.businessAdd(daysToPrint);
    printingPlusShipDate = printDate.format(dateFormat);

    if (daysToPrint === 3) {
      // for our order manager, this is 4, not 3.
      // i.e. printingPlusShipDate is a string based on
      // printingPlusShipDateObject - 1,
      printDate = today.businessAdd(4);
    }
  }

  return {
    printingPlusShipDate: printingPlusShipDate,
    letterpressShipDate: letterpressShipDate,
    pistachioPressShipDateObject: printDateLetterpress,
    printingPlusShipDateObject: printDate
  };
}

module.exports = calculateShipDate;